import styled from "styled-components";

/* Container do botão */
export const ListItemDivContract = styled.div `
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
`;

/* Botão Criar */
export const StyledButtonCriarContract = styled.button `
  width: 10vw;

  @media screen and (max-width: 768px) {
    width: min(100%, 200px);
    max-width: 100%;
  }

  height: 4vh;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  margin: 20px 35px 0 0;

  border-radius: 20px;

  border: 1px solid var(--accent-soft);
  background: var(--accent-soft);
  color: var(--accent);

  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 0.3px;

  cursor: pointer;

  transition: all 0.25s ease;
  backdrop-filter: blur(6px);

  &:hover {
    background: var(--accent-soft);
    border-color: var(--accent);
    transform: translateY(-1px);
  }

  &:active {
    transform: scale(0.97);
  }
`;

/* Botão Ver */
export const StyledButtonVerContrato = styled.button `
  background-color: var(--accent);
  color: var(--text-on-accent);
  border: none;
  padding: 10px 18px;
  margin: 20px 35px 0 0px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: 0.2s;

  &:hover {
    background-color: var(--accent-hover);
  }
`;

/* Modal overlay */
export const ModalOverlay = styled.div `
  position: fixed;
  inset: 0;
  background: var(--surface-overlay);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

/* Modal content */
export const ModalContent = styled.div `
  background: var(--input-bg);
  padding: 30px;
  width: 600px;
  max-width: 90%;
  border-radius: 12px;
  position: relative;
  max-height: 80vh;
  overflow-y: auto;
`;

/* Botão fechar */
export const CloseButton = styled.button `
  position: absolute;
  right: 15px;
  top: 10px;
  border: none;
  background: none;
  font-size: 24px;
  cursor: pointer;
`;

/* Título */
export const ModalTitle = styled.h2 `
  margin-bottom: 20px;
`;

/* Container dos dados */
export const ContractContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

/* Item */
export const ContractItem = styled.div `
  display: flex;
  flex-direction: column;
`;

/* Label */
export const ContractLabel = styled.span `
  font-weight: bold;
  margin-bottom: 5px;
`;

/* Valor */
export const ContractValue = styled.span `
  background: var(--surface-2);
  padding: 8px;
  border-radius: 6px;
  word-break: break-all;
`;
